/**
 * Component
 * @type {function(): {}}
 * @name notifComponent
 */
export class Parallax {

    /**
     * @arg {object} properties
     * @constructor
     */
    constructor(properties) {

        // define options
        this.options = {...{
                selector: '[data-parallax]'
            }, ...properties
        };

        // select items
        this.items = document.querySelectorAll(this.options.selector);

        this.init()
    }

    init() {
        this.watchScroll()
    }

    /**
     * Update items array when DOM changed
     */
    updateItems() {
        this.items = document.querySelectorAll(this.options.selector);
    }

    clearItem(item) {
        item.style.transform = ''
    }

    moveItems() {
        if (window.pageYOffset <= 0) return
        for (const item of this.items) {
            const breakpoints = item.dataset.parallaxBreak
            if (breakpoints) {
                for (const bp of JSON.parse(breakpoints)) {
                    if (bp.direction === 'down' && window.innerWidth > bp.width) {
                        return this.clearItem(item)
                    } else if (bp.direction === 'up' && window.innerWidth < bp.width) {
                        return this.clearItem(item)
                    }
                }
            }
            const itemRect = item.getBoundingClientRect()
            const direction = item.dataset.parallaxDirection
            let itemCenter = (itemRect.y+window.pageYOffset) + (itemRect.height/2)
            let pageCenter = window.pageYOffset + (window.innerHeight/2)
            let value = ((itemCenter/pageCenter) - 1) * -1 * 100
            let factor = item.dataset.parallaxFactor ? item.dataset.parallaxFactor : 2
            let translatevalue = value.toFixed(2) * factor
            if (direction === 'x') {
                item.style.transform = `translate3d(${translatevalue}px,0,0)`
            } else if (direction === 'y') {
                item.style.transform = `translate3d(0,${translatevalue}px,0)`
            } else {
                item.style.transform = `translate3d(0,${translatevalue}px,0)`
            }
        }
    }

    watchScroll() {
        window.addEventListener('scroll', () => {
            this.moveItems()
        });
    }
}
